// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-3PAgz";
var _4 = "subheader-3vozV";
var _5 = "wrapper-3sX3l";
var _6 = "content-2_Uvq";
var _7 = "content_text-1CfTA";
var _8 = "content_disclaimer-hDeLt";
var _9 = "content_wrapper-6TgBM";
var _a = "total-1O3RV";
var _b = "total__price-3n7BX";
var _c = "total__price_withBorder-1Cpo-";
var _d = "total__clear-3io-g";
var _e = "footer-3FRZX";
var _f = "controls-F9Hvv";
var _10 = "button-1T9xN";
var _11 = "cancel-3VvBo";
var _12 = "button_disabled-Yp6Cs";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "subheader", _5 as "wrapper", _6 as "content", _7 as "content_text", _8 as "content_disclaimer", _9 as "content_wrapper", _a as "total", _b as "total__price", _c as "total__price_withBorder", _d as "total__clear", _e as "footer", _f as "controls", _10 as "button", _11 as "cancel", _12 as "button_disabled" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "subheader": _4, "wrapper": _5, "content": _6, "content_text": _7, "content_disclaimer": _8, "content_wrapper": _9, "total": _a, "total__price": _b, "total__price_withBorder": _c, "total__clear": _d, "footer": _e, "controls": _f, "button": _10, "cancel": _11, "button_disabled": _12 }
